import { Column, Row } from 'app/design/primitives/box';

import { PlaceholderLine } from 'app/overrides/rn-placeholder/PlaceholderLine';
import { PlaceholderMedia } from 'app/overrides/rn-placeholder/PlaceholderMedia';
import { Shine } from 'app/overrides/rn-placeholder/animations/Shine';
import React from 'react';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

function ChipSkeleton({ width }: { width: number }) {
  return <PlaceholderMedia style={{ width, height: 28, borderRadius: theme.borderRadii['radius.full'] }} />;
}

export function TagsSectionSkeleton({ chipWidths }: { chipWidths: number[] }) {
  return (
    <Shine reverse={false}>
      <Column gap="spacing.general.x2">
        <Row justifyContent="space-between" alignItems="center" marginBottom="spacing.general.x2">
          <PlaceholderLine noMargin height={20} style={{ width: 160, borderRadius: 4 }} />
          <PlaceholderLine noMargin height={14} style={{ width: 70, borderRadius: 4 }} />
        </Row>
        <Row style={{ flexWrap: 'wrap', gap: theme.spacing['spacing.general.x1'] }}>
          {chipWidths.map((w) => (
            <ChipSkeleton key={w} width={w} />
          ))}
        </Row>
      </Column>
    </Shine>
  );
}
